import { PageController } from '@client/components/_core/layout/PageController';
import { CatastropheEventEdit } from '@client/components/claims/CatastropheEventEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/claims/catastrophe-events/edit/$catastropheEventId',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit catastrophe event',
        },
    },
    params: {
        parse({ catastropheEventId }) {
            return {
                catastropheEventId: BigInt(catastropheEventId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <CatastropheEventEdit action={['edit', Route.useParams().catastropheEventId]} />
        </PageController>
    );
}
